import { render, staticRenderFns } from "./VeJwBkJiankaoList.vue?vue&type=template&id=6a1e590e"
import script from "./VeJwBkJiankaoList.vue?vue&type=script&lang=js"
export * from "./VeJwBkJiankaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports